import type { RowData, Table } from '@tanstack/react-table';
import { TanStackTableCSVButton } from './csv-button';
import { TanStackTablePrintButton } from './print-button';

type ReportActionsProps<T extends RowData> = {
  table: Table<T> | null;
  title: string;
};

export function ReportActions<T extends RowData>({ table, title }: ReportActionsProps<T>) {
  return (
    <>
      <TanStackTablePrintButton table={table} title={title} />
      <TanStackTableCSVButton
        table={table}
        filename={`${title.toLowerCase().replace(/ /g, '-')}.csv`}
      />
    </>
  );
}
